// extracted by mini-css-extract-plugin
module.exports = {"ProxySqlLbCompareDashboard":"ProxySqlLbCompareDashboard_HV4kO"};